import Link from '@jetbrains/ring-ui/components/link/link'
import {useMemo} from 'react'

import SettingsBlock from '../../../../components/SettingsBlock/SettingsBlock'

import PipelineParameter from './PipelineParameter/PipelineParameter'
import PipelineParameterCreateForm from './PipelineParameterCreateForm/PipelineParameterCreateForm'
import {pipelineParametersNoticeLink} from './PipelineParameters.consts'
import usePipelineParameters from './usePipelineParameters'

const PipelineParameters = () => {
  const {
    settingsBlockId,
    isSettingsBlockCollapsible,
    settingsBlockTitle,
    parameters,
    isOutOfLimit,
    addParameter,
    keys,
    deletedParameters,
    isCreateParameterMode,
    pipelineParameterMultiplyConfirmHandler,
    setCreateParameterMode,
  } = usePipelineParameters()

  return useMemo(
    () => (
      <SettingsBlock
        id={settingsBlockId}
        collapsible={isSettingsBlockCollapsible}
        title={settingsBlockTitle}
        disabled={isCreateParameterMode}
        details={
          <>
            <Link
              target="_blank"
              href={pipelineParametersNoticeLink}
              rel="noreferrer"
            >{`Name-value pairs`}</Link>
            {' that you can reference in build scripts using the %ParameterName% syntax'}
          </>
        }
        collapsedNote={Object.entries(parameters)
          .filter(([key]) => !deletedParameters?.includes(key))
          .map(([key, value]) => `${key}=${value}`)
          .join(', ')}
        onAddClick={!isOutOfLimit ? addParameter : undefined}
      >
        {keys.map(key => {
          const value = parameters[key]
          const isDeleted = deletedParameters?.includes(key)

          return <PipelineParameter key={key} value={value} name={key} deleted={isDeleted} />
        })}

        {isCreateParameterMode && (
          <PipelineParameterCreateForm
            onConfirm={pipelineParameterMultiplyConfirmHandler}
            onDeleteAll={() => setCreateParameterMode(false)}
          />
        )}
      </SettingsBlock>
    ),
    [
      settingsBlockId,
      isSettingsBlockCollapsible,
      settingsBlockTitle,
      parameters,
      isOutOfLimit,
      addParameter,
      keys,
      isCreateParameterMode,
      pipelineParameterMultiplyConfirmHandler,
      deletedParameters,
      setCreateParameterMode,
    ],
  )
}

export default PipelineParameters
